import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { api } from "../axios/api";
import { Logo2 } from "../static";
import { ArrowLeft } from "lucide-react";

const RequestAndVerify = () => {
  const [step, setStep] = useState(1); // 1: Solicitar, 2: Validar
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Etapa 1: Solicitar Código
  const handleRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/request", { email });
      Swal.fire("Enviado!", "Verifique o código de 6 dígitos no seu e-mail.", "success");
      setStep(2);
    } catch (err) {
      Swal.fire("Erro", err.response?.data?.error || "Falha ao enviar e-mail.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Etapa 2: Validar Código
  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/validate", { email, code });
      // Navega para a tela de redefinir, levando os dados necessários
      navigate("/auth/redefinir-senha", { state: { email, code } });
    } catch (err) {
      Swal.fire("Erro", "Código inválido ou expirado.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="facturize-auth-page min-vh-100 d-flex align-items-center justify-content-center">
      <div className="vignette" />
      
      <div className="facturize-setup-card p-4 col-12 col-md-4 animate__animated animate__fadeIn">
        <header className="text-center mb-4">
          <img src={Logo2} alt="Facturize" width="120" />
          <h4 className="mt-3 step-title">{step === 1 ? "Recuperar Senha" : "Verificação"}</h4>
          <p className="text-muted small">
            {step === 1 ? "Insira seu e-mail para receber as instruções." : "Insira o código de 6 dígitos enviado para o seu e-mail."}
          </p>
        </header>

        {step === 1 ? (
          <form onSubmit={handleRequest}>
            <label className="auth-label">E-mail</label>
            <input
              type="email"
              className="auth-field mb-3"
              placeholder="exemplo@facturize.co.ao"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={loading} className="btn-setup-primary w-100">
              {loading ? "Enviando..." : "Solicitar Código"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerify}>
            <label className="auth-label text-center d-block">Código de Segurança</label>
            <input
              type="text"
              maxLength={6}
              className="auth-field mb-3 text-center code-input"
              placeholder="000000"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ""))}
              required
            />
            <button type="submit" disabled={loading} className="btn-setup-primary w-100">
              {loading ? "Validando..." : "Validar Código"}
            </button>
            <button type="button" className="btn btn-link w-100 mt-2 back-btn" onClick={() => setStep(1)}>
              <ArrowLeft size={16} /> Voltar
            </button>
          </form>
        )}
      </div>

      <style>{`
        .facturize-auth-page { background: #000b1a; font-family: 'Inter', sans-serif; position: relative; }
        .vignette { position: absolute; width: 100%; height: 100%; background: radial-gradient(circle at center, rgba(0, 86, 179, 0.15) 0%, #000b1a 100%); }
        .facturize-setup-card { background: #fff; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,0,0,0.3); z-index: 1; }
        .step-title { font-weight: 800; color: #0f172a; }
        .auth-label { font-size: 11px; font-weight: 700; color: #64748b; margin-bottom: 8px; text-transform: uppercase; }
        .auth-field { width: 100%; padding: 12px; border: 1.5px solid #e2e8f0; border-radius: 12px; background: #f8fafc; transition: 0.2s; }
        .auth-field:focus { border-color: #0078d4; outline: none; box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.1); }
        .code-input { font-size: 1.5rem !important; letter-spacing: 0.5rem !important; font-weight: 700; }
        .btn-setup-primary { background: #0078d4; color: white; border: none; padding: 12px; border-radius: 12px; font-weight: 700; transition: 0.2s; }
        .btn-setup-primary:hover:not(:disabled) { background: #005a9e; }
        .back-btn { color: #64748b; font-size: 14px; text-decoration: none; }
      `}</style>
    </div>
  );
};

export default RequestAndVerify;